/**
 * Variant Option Info - Optimized module for variant interactions
 */
(function() {
  'use strict';

  // Format currency helper
  const formatCurrency = (cents) => new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(cents / 100);

  // Update visual selection state
  const updateSelectionUI = (input) => {
    const fieldset = input.closest('.variant-input-wrapper');
    if (!fieldset) return;

    fieldset.querySelectorAll('.new-variant-design').forEach(el =>
      el.classList.remove('is-selected')
    );

    input.nextElementSibling?.classList.add('is-selected');
  };

  // Update variant label
  const updateVariantLabel = (input, sectionId) => {
    const fieldset = input.closest('.variant-input-wrapper');
    const optionNum = fieldset?.dataset.optionIndex?.replace('option', '');
    if (!optionNum) return;

    const label = document.getElementById(`variant-selected-${sectionId}-${optionNum}`);
    if (label) label.textContent = `–\u00A0${input.value}`;
  };

  // Update bellacash amount
  const updateBellacash = (price) => {
    const el = document.getElementById('bellacash-amount');
    if (el) el.textContent = formatCurrency(price / 10);
  };

  // Handle variant input change (radio buttons)
  document.addEventListener('change', (e) => {
    const input = e.target;

    // Check if it's a variant radio button
    if (!input.matches('input[type="radio"][data-option-value]')) return;

    const variantRadios = input.closest('variant-radios');
    const sectionId = variantRadios?.dataset.section;

    if (sectionId) {
      updateVariantLabel(input, sectionId);
      updateSelectionUI(input);
    }
  });

  // Handle variant change event (from global.js)
    // Update prepaid online banner price and savings
  const formatMoney = (paise) => {
    const themeCurrency = window.theme && window.theme.Currency;
    const moneyFormat = window.shopSettings && window.shopSettings.moneyFormat;

    if (themeCurrency && typeof themeCurrency.formatMoney === 'function') {
      return themeCurrency.formatMoney(paise, moneyFormat);
    }

    // Fallback: use local formatter if theme currency helper is unavailable
    return formatCurrency(paise);
  };

  const updatePrepaidBanner = (price) => {
    const prepaidPaise = Math.floor(price * 95 / 100);
    const savingsPaise = price - prepaidPaise;
    document.querySelectorAll('.prepaid-online-banner__price').forEach(el => {
      el.innerHTML = 'Pay ' + formatMoney(prepaidPaise);
      el.dataset.paise = prepaidPaise;
    });
    document.querySelectorAll('.prepaid-online-banner__savings').forEach(el => {
      el.innerHTML = formatMoney(savingsPaise);
      el.dataset.paise = savingsPaise;
    });
  };
    document.addEventListener('variant:change', (e) => {
    const price = e.detail?.variant?.price;
    if (price) {
      updateBellacash(price);
      updatePrepaidBanner(price);
    }

    // Reset quantity with MutationObserver
    const observer = new MutationObserver(() => {
      const inputs = document.querySelectorAll(
        '.price-quantity-wrapper .quantity__input'
      );

      if (inputs.length) {
        inputs.forEach(input => {
          input.value = 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        observer.disconnect();
        console.log('Quantity reset via observer');
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

})();
// price update manual
